import React, { createContext, useContext, useEffect, useState, useCallback, useRef } from "react";
import { apiFetch, clearApiCache } from "../api";

const ClinicaActualContext = createContext({
  clinica: null,
  miProfesional: null,
  miProfesionalId: null,
  profesionales: [],
  loading: true,
  refrescar: () => {},
});

export function ClinicaActualProvider({ children }) {
  const [clinica, setClinica] = useState(null);
  const [miProfesional, setMiProfesional] = useState(null);
  const [profesionales, setProfesionales] = useState([]);
  const [loading, setLoading] = useState(true);
  const mountedRef = useRef(true);

  const cargar = useCallback(async () => {
    setLoading(true);
    try {
      const [c, mp, profs] = await Promise.all([
        apiFetch("/configuracion/clinica-actual", { cache: true }).catch(() => null),
        apiFetch("/equipo/mi-profesional-id", { cache: true }).catch(() => null),
        apiFetch("/profesionales/", { cache: true }).catch(() => []),
      ]);
      if (!mountedRef.current) return;
      setClinica(c || null);
      setMiProfesional(mp || null);
      setProfesionales(Array.isArray(profs) ? profs.filter(p => p.activo !== false) : []);
    } finally {
      if (mountedRef.current) setLoading(false);
    }
  }, []);

  const refrescar = useCallback(() => {
    clearApiCache();
    return cargar();
  }, [cargar]);

  useEffect(() => {
    mountedRef.current = true;
    cargar();
    const onUpdate = () => refrescar();
    window.addEventListener("clinica-branding-updated", onUpdate);
    return () => {
      mountedRef.current = false;
      window.removeEventListener("clinica-branding-updated", onUpdate);
    };
  }, [cargar, refrescar]);

  const miProfesionalId = miProfesional?.profesional_id ?? null;

  return (
    <ClinicaActualContext.Provider value={{ clinica, miProfesional, miProfesionalId, profesionales, loading, refrescar }}>
      {children}
    </ClinicaActualContext.Provider>
  );
}

export const useClinicaActual = () => useContext(ClinicaActualContext);
